import { SignalDispatcher } from 'ste-signals';
import { SimpleEventDispatcher } from 'ste-simple-events';
import { EntityType } from '@texas/api/endpoints/trackerApi';

export interface TagLinksUpdatedEvent {
  entityId: number;
  entityType: EntityType;
}

export const tagEvents = {
  tagUpdated: new SignalDispatcher(),
  tagLinksUpdated: new SimpleEventDispatcher<TagLinksUpdatedEvent>(),
};
